<form
  [formGroup]="form"
  (ngSubmit)="onFormSubmit()"
  #formRef="ngForm"
  [patchForm]="formValues$ | async"
  [canEdit]="[accessRights.ConfigurationOptions_write]"
  [canEdit]="[accessRights.Settings_write]"
>
  <!-- Card -->
  <section class="card mb-3">
    <div class="card-header card-collapse">
      <!-- Header -->
      <h2 class="accordion-header">
        <button
          class="accordion-button"
          type="button"
          [attr.aria-expanded]="isCollapsed ? 'false' : 'true'"
          (click)="isCollapsed = !isCollapsed"
          aria-controls="loginPage"
        >
          <span class="fs-3">{{
            'configurationOptionModule.loginPage' | translate
          }}</span>
          <i
            class="fa fa-fw"
            [ngClass]="isCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
            attr.aria-label="{{ 'wcag.toggleSection' | translate }}"
            role="img"
          ></i>
        </button>
      </h2>

      <!-- End Header -->
    </div>

    <div *ngIf="!isCollapsed" id="loginPage" class="card-body">
      <div class="mb-4">
        <label class="form-label">{{
          'configurationOptionModule.loginPageHTML' | translate
        }}</label>
        <summernote-languages
          [formData]="form"
          [summerNoteFieldEn]="'en_landing_page_branding'"
          [summerNoteFieldNl]="'nl_landing_page_branding'"
          [summerNoteFieldDe]="'de_landing_page_branding'"
          [summerNoteFieldFr]="'fr_landing_page_branding'"
        ></summernote-languages>
      </div>
      <ng-container *ngFor="let title of sectionTitle">
        <h3>{{ 'configurationOptionModule.' + title | translate }}</h3>
        <fieldset
          *ngFor="let subTitle of subSectionTitle[title].name; let i = index"
          class="mb-4"
        >
          <legend class="form-label" id="{{ title }}-{{ i }}">
            {{ 'configurationOptionModule.' + subTitle | translate }}
          </legend>
          <div class="row g-2">
            <ng-container *ngFor="let langCode of availableLanguageCodes">
              <div class="col-lg-6" *ngIf="availableLanguages[langCode]">
                <div class="input-group">
                  <span class="input-group-text"
                    ><span
                      class="flag flag-{{ langCode }}"
                      id="lang-{{ title }}-{{ i }}"
                      role="img"
                      attr.aria-label="{{ 'wcag.' + langCode | translate }}"
                    >
                    </span
                  ></span>

                  <input
                    type="text"
                    class="form-control"
                    rows="8"
                    attr.aria-labelledby="{{ title }}-{{ i }} flag-{{
                      title
                    }}-{{ i }}"
                    formControlName="{{
                      subSectionTitle[title].formControlName[i]
                    }}{{
                      langCode.charAt(0).toUpperCase() + langCode.slice(1)
                    }}"
                  />
                </div>
              </div>
            </ng-container>
          </div>
        </fieldset>
      </ng-container>

      <div class="form-footer sticky-bottom">
        <div
          class="spinner-border"
          role="status"
          *ngIf="(isLoading$ | async) || isloadingFromParentPage"
          attr.aria-label="{{ 'general.loading' | translate }}"
        >
        </div>
        <button
          class="btn btn-primary"
          type="submit"
          [canSee]="[accessRights.Settings_write]"
          [canSee]="[accessRights.ConfigurationOptions_write]"
        >
          {{ 'general.save' | translate }}
        </button>
      </div>
    </div>
  </section>
  <!-- End Card -->
</form>
